import Merchant from "domain/merchant";
import { UserType, UserConfiguration, IdentityType } from "./loggedInUser";
import { ProducerAccount } from "features/settings/producers/producerAccount";

export default class UserState {
    isLoggingIn: boolean = false;
    isLoggedIn: boolean = false;
    isLoginFailed: boolean = false;
    accessToken: string = null;
    name: string = null;
    internalId: string = null;
    merchants: Merchant[] = null;
    activeMerchant: Merchant = null;
    type: UserType = null;
    identityType: IdentityType = null;
    userConfiguration: UserConfiguration = null;
    isCustomer: boolean = false;
    accounts: string[] = [];
    customerAccounts: ProducerAccount[] = [];
}